module.exports = __webpack_public_path__ + "img/52.7eb253c7.png";